
export default function initialise (config) {
  if (!config) { return }

  window._iub = window._iub || {}
  window._iub.csConfiguration = config

  const iubendaStub = document.createElement('script')
  iubendaStub.setAttribute(
    'src',
    '//cdn.iubenda.com/cs/tcf/stub-v2.js'
  )

  const iubenda = document.createElement('script')
  iubenda.setAttribute(
    'src',
    '//cdn.iubenda.com/cs/iubenda_cs.js'
  )
  iubenda.setAttribute('charset', 'UTF-8')

  document.head.appendChild(iubendaStub)
  document.head.appendChild(iubenda)
}
